/**
 * @format
 */
import 'react-native-gesture-handler';
import {AppRegistry , Platform} from 'react-native';
import App from './App';
import {expo} from './app.json';
const appName = expo.name;
import {registerRootComponent} from 'expo';


if (Platform.OS === 'web') {
    registerRootComponent(App);
} else {
    AppRegistry.registerComponent(appName, () => App);
}